/**
 * Fût Mauricie — Drip Tray Configurator engine (v1)
 * Pricing formula ported 1:1 from ERP PricingEngine (validated against production quotes).
 * Constraints per Etienne 2026-07-07: max width 100", 2" min spacing, Y always centered,
 * grille seams every ~36" and never on a glass rinser (rinser footprint = 6").
 */
window.FMTray = (function () {
  'use strict';

  var FAMILIES = {
    standard: { label: 'Standard', defaultDepth: 6, minDepth: 6, maxDepth: 12, recessedMult: false },
    recessed: { label: 'Recessed', defaultDepth: 6, minDepth: 6, maxDepth: 12, recessedMult: true },
    'x-pressed': { label: 'X-Pressed', defaultDepth: 8, minDepth: 8, maxDepth: 12, recessedMult: true },
    platform: {
      label: 'Platform', defaultDepth: 14.8125, minDepth: 14.8125, maxDepth: 18.8125, recessedMult: false,
      depthOptions: [14.8125, 17.8125, 18.8125],
      // fixed bands back→front; extra depth beyond 14.8125 grows the platform band
      bands: { backSlope: 1.3125, platform: 6, tray: 6.125, frontRaise: 1.375 }
    }
  };

  /** Fût Mauricie towers: column Ø (the hole) + flange Ø (drives Y position & platform depth). */
  var TOWERS = [
    { key: '3in',        label: '3″ tower',        labelFr: 'Colonne 3″',        column: 3,   flange: 4.413 },
    { key: '3in-copper', label: '3″ copper tower', labelFr: 'Colonne 3″ cuivre', column: 3,   flange: 4.422 },
    { key: '3.5-rough',  label: '3.5″ Rough',      labelFr: 'Rough 3,5″',        column: 3.5, flange: 7.5 },
    { key: '4in',        label: '4″ tower',        labelFr: 'Colonne 4″',        column: 4,   flange: 5.625 },
    { key: '4in-copper', label: '4″ copper tower', labelFr: 'Colonne 4″ cuivre', column: 4,   flange: 5.719 },
    { key: '4-odyssey',  label: '4″ Odyssey',      labelFr: 'Odyssey 4″',        column: 4,   flange: 7 },
    { key: '4.5-rough',  label: '4.5″ Rough',      labelFr: 'Rough 4,5″',        column: 4.5, flange: 9 },
    { key: '6in',        label: '6″ tower',        labelFr: 'Colonne 6″',        column: 6,   flange: 8.875 }
  ];

  var FLANGE_GRILLE_MARGIN = 0.125; // flange edge sits this close to the grille (tray band)

  /** Platform band depth at a given overall depth. */
  function platformBand(depth) {
    return FAMILIES.platform.bands.platform + (depth - FAMILIES.platform.defaultDepth);
  }

  /** Smallest platform depth whose platform band fits the flange (+0.125″ grille margin), with real slack — zero-slack fits go up a size. */
  function platformDepthFor(flange) {
    var opts = FAMILIES.platform.depthOptions;
    for (var i = 0; i < opts.length; i++) {
      if (flange + FLANGE_GRILLE_MARGIN < platformBand(opts[i])) return opts[i];
    }
    return opts[opts.length - 1];
  }

  /** Hole-center setback from the platform/tray boundary (the grille edge). */
  function holeSetback(flange) {
    return FLANGE_GRILLE_MARGIN + flange / 2;
  }

  var LIMITS = {
    minWidth: 12,
    maxWidth: 100,
    maxDrains: 3,
    maxRinsers: 2,
    minSpacing: 2,        // inches between any two elements (edge-to-edge of centers)
    edgeMargin: 2,        // element center min distance from tray ends
    rinserFootprint: 6,   // inches of width a glass rinser occupies
    grilleSection: 36,    // target max grille section length
    maxGrilleSections: 5, // manufacturing stop — never more than 5 inserts
    snap: 0.25
  };

  var PRICE = {
    perSqFt: 100,         // ((W*D)/144) * 100
    rinser: 95,
    drain: 35,
    margin: 1.5,
    recessedMult: 1.3,
    cutout: 175,
    paint: 125,
    minimum: 150,
    ladderMin: 150,
    ladderMax: 2400,
    ladderStep: 25
  };

  /** Exact ERP retail formula. */
  function retailPrice(opts) {
    var fam = FAMILIES[opts.family] || FAMILIES.standard;
    var base = ((opts.width * opts.depth) / 144) * PRICE.perSqFt
      + (opts.rinsers || 0) * PRICE.rinser
      + (opts.drains || 0) * PRICE.drain;
    var price = base * PRICE.margin * (fam.recessedMult ? PRICE.recessedMult : 1)
      + (opts.cutout ? PRICE.cutout : 0);
    price = Math.max(price, PRICE.minimum);
    if (opts.painted) price += PRICE.paint;
    return Math.round(price * 100) / 100;
  }

  /** Round exact price UP to the next ladder rung. */
  function ladderPrice(exact) {
    var rung = Math.ceil(exact / PRICE.ladderStep) * PRICE.ladderStep;
    return Math.min(Math.max(rung, PRICE.ladderMin), PRICE.ladderMax);
  }

  /**
   * Grille inserts are always EQUAL lengths — seams never move.
   * If an equal split lands on a glass rinser, add an insert instead (2 → 3 …).
   * Hard stop at 5 inserts: past that, `ok: false` (the rinser must move).
   */
  function grilleSeams(width, rinserXs) {
    var conflicts = function (count) {
      for (var i = 1; i < count; i++) {
        var x = (width / count) * i;
        var hit = (rinserXs || []).some(function (rx) {
          return Math.abs(x - rx) < LIMITS.rinserFootprint / 2 + 0.25;
        });
        if (hit) return true;
      }
      return false;
    };
    var count = Math.max(1, Math.ceil(width / LIMITS.grilleSection));
    while (count <= LIMITS.maxGrilleSections && conflicts(count)) count++;
    var ok = count <= LIMITS.maxGrilleSections;
    if (!ok) count = LIMITS.maxGrilleSections;
    var seams = [];
    for (var i = 1; i < count; i++) seams.push(Math.round((width / count) * i * 4) / 4);
    return { count: count, seams: seams, ok: ok };
  }

  /** Validate a full configuration. Returns { ok, errors: [{code, message}] }. */
  function validate(cfg) {
    var errors = [];
    var fam = FAMILIES[cfg.family];
    if (!fam) errors.push({ code: 'family', message: 'Unknown tray type.' });
    if (!(cfg.width >= LIMITS.minWidth && cfg.width <= LIMITS.maxWidth))
      errors.push({ code: 'width', message: 'Width must be between ' + LIMITS.minWidth + '" and ' + LIMITS.maxWidth + '".' });
    if (fam && !(cfg.depth >= fam.minDepth && cfg.depth <= fam.maxDepth))
      errors.push({ code: 'depth', message: 'Depth must be between ' + fam.minDepth + '" and ' + fam.maxDepth + '" for ' + fam.label + '.' });

    var drains = cfg.drainXs || [];
    var rinsers = cfg.rinserXs || [];
    if (drains.length > LIMITS.maxDrains) errors.push({ code: 'drains', message: 'Maximum ' + LIMITS.maxDrains + ' drains.' });
    if (rinsers.length > LIMITS.maxRinsers) errors.push({ code: 'rinsers', message: 'Maximum ' + LIMITS.maxRinsers + ' glass rinsers.' });
    if (rinsers.length > 0 && drains.length === 0)
      errors.push({ code: 'rinser-drain', message: 'A glass rinser needs at least one drain.' });

    var all = drains.map(function (x) { return { x: x, t: 'drain' }; })
      .concat(rinsers.map(function (x) { return { x: x, t: 'rinser' }; }));
    all.forEach(function (el) {
      var half = el.t === 'rinser' ? LIMITS.rinserFootprint / 2 : 0;
      if (el.x - half < LIMITS.edgeMargin || el.x + half > cfg.width - LIMITS.edgeMargin)
        errors.push({ code: 'edge', message: 'Keep elements at least ' + LIMITS.edgeMargin + '" from the tray ends.' });
    });
    all.sort(function (a, b) { return a.x - b.x; });
    for (var i = 1; i < all.length; i++) {
      var gap = all[i].x - all[i - 1].x;
      // drain–rinser and drain–drain: plain 2″; rinser–rinser: footprints apply
      var need = LIMITS.minSpacing
        + (all[i].t === 'rinser' && all[i - 1].t === 'rinser' ? LIMITS.rinserFootprint : 0);
      if (gap < need)
        errors.push({ code: 'spacing', message: 'Elements need at least ' + LIMITS.minSpacing + '" of clearance between them.' });
    }
    if (rinsers.length > 0 && !grilleSeams(cfg.width, rinsers).ok)
      errors.push({ code: 'grille', message: 'Even with ' + LIMITS.maxGrilleSections + ' grille inserts, a split lands on a glass rinser — shift a rinser an inch or two.' });

    if (cfg.family === 'platform') {
      if (FAMILIES.platform.depthOptions.indexOf(cfg.depth) === -1)
        errors.push({ code: 'depth', message: 'Platform depth must be 14.8125″, 17.8125″ or 18.8125″.' });
      var holes = cfg.holeXs || [];
      var flange = cfg.flange || 0;
      if (holes.length > 0) {
        if (flange + FLANGE_GRILLE_MARGIN >= platformBand(cfg.depth))
          errors.push({ code: 'flange-depth', message: 'This flange needs a deeper platform.' });
        holes.forEach(function (x) {
          if (x - flange / 2 < LIMITS.edgeMargin || x + flange / 2 > cfg.width - LIMITS.edgeMargin)
            errors.push({ code: 'hole-edge', message: 'Keep tower flanges at least ' + LIMITS.edgeMargin + '" from the tray ends.' });
        });
        if (holes.length === 2 && Math.abs(holes[1] - holes[0]) < flange + 1)
          errors.push({ code: 'hole-spacing', message: 'Leg centers need at least the flange width + 1" between them.' });
      }
    }
    return { ok: errors.length === 0, errors: errors };
  }

  function snap(x) { return Math.round(x / LIMITS.snap) * LIMITS.snap; }

  /**
   * Preset placement (Etienne 2026-08-12): spread ONE group (drains or rinsers)
   * uniformly over the chosen half of the width — left [0, W/2], center
   * [W/4, 3W/4], right [W/2, W] — then nudge the COMBINED layout (both groups)
   * with the same forward/backward relaxation as the reset button so edge
   * margins and spacing hold. Pure: returns { drainXs, rinserXs }, inputs untouched.
   * On a tray too narrow for the request, relaxation leaves the closest legal-ish
   * layout and validate() reports the conflict — same contract as dragging.
   */
  function presetLayout(cfg, group, align) {
    var W = cfg.width;
    var drains = (cfg.drainXs || []).slice();
    var rinsers = (cfg.rinserXs || []).slice();
    var target = group === 'rinsers' ? rinsers : drains;
    var n = target.length;
    if (!n) return { drainXs: drains, rinserXs: rinsers };
    var segW = W / 2;
    var x0 = align === 'left' ? 0 : align === 'right' ? segW : segW / 2;
    for (var i = 0; i < n; i++) target[i] = x0 + (segW * (i + 1)) / (n + 1);

    var items = drains.map(function (x) { return { t: 'drain', x: x }; })
      .concat(rinsers.map(function (x) { return { t: 'rinser', x: x }; }));
    items.sort(function (a, b) { return a.x - b.x; });
    var half = function (t) { return t === 'rinser' ? LIMITS.rinserFootprint / 2 : 0; };
    var need = function (a, b) { return LIMITS.minSpacing + (a === 'rinser' && b === 'rinser' ? LIMITS.rinserFootprint : 0); };
    var m = items.length;
    for (var j = 0; j < m; j++) {
      var lo = j === 0 ? LIMITS.edgeMargin + half(items[j].t) : items[j - 1].x + need(items[j - 1].t, items[j].t);
      if (items[j].x < lo) items[j].x = lo;
    }
    for (var k = m - 1; k >= 0; k--) {
      var hi = k === m - 1 ? W - LIMITS.edgeMargin - half(items[k].t) : items[k + 1].x - need(items[k].t, items[k + 1].t);
      if (items[k].x > hi) items[k].x = hi;
    }
    var outDrains = [], outRinsers = [];
    items.forEach(function (el) { (el.t === 'drain' ? outDrains : outRinsers).push(snap(el.x)); });
    return { drainXs: outDrains, rinserXs: outRinsers };
  }

  return {
    FAMILIES: FAMILIES,
    LIMITS: LIMITS,
    PRICE: PRICE,
    TOWERS: TOWERS,
    retailPrice: retailPrice,
    ladderPrice: ladderPrice,
    grilleSeams: grilleSeams,
    platformBand: platformBand,
    platformDepthFor: platformDepthFor,
    holeSetback: holeSetback,
    validate: validate,
    snap: snap,
    presetLayout: presetLayout
  };
})();
